<template>
  <b-modal
    ref="modal"
    :title="$_.capitalize($t('service-scheduler'))"
    @ok="okClicked"
    size="xl"
    :cancel-disabled="true"
  >
    <service-scheduler :settings-var="settingsVar" />
    <template v-slot:modal-footer="{ ok, cancel, hide }">
      <b-button @click="ok()">
        {{ $t('close') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import ServiceScheduler from '@/components/services/service/scheduler/ServiceScheduler.vue';

export default {
  name: 'SchedulerModal',
  props: {
    settingsVar: {
      type: Object,
      required: true,
    },
  },
  methods: {
    okClicked() {
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
  components: { ServiceScheduler },
};
</script>

<style scoped>

</style>
